(function () {
  'use strict';

  var module = angular.module('uwAgenda.website.privacypolicy');

  module.controller('PrivacyPolicyController', [
    '$scope',
    '$timeout',
    'Alert',
    'PrivacyPolicyService',
    'Languages',
    PrivacyPolicyControllerFn
  ]);

  function PrivacyPolicyControllerFn(
    $scope,
    $timeout,
    Alert,
    PrivacyPolicyService,
    Languages
  ) {
    var vm = this;

    vm.languages = Object.keys(Languages)
      .filter(function (languageName) {
        return languageName !== 'Unknown';
      })
      .map(function (languageName) {
        var language = Languages[languageName];
        return {
          id: language.id,
          iso: language.iso
        };
      });
    vm.uploadedPolicies = {};
    vm.selectedFiles = {};
    vm.isLoading = false;
    vm.defaultPolicyUrl = '';

    // Methods
    vm.onFileSelected = onFileSelected;
    vm.uploadPolicy = uploadPolicy;
    vm.openDownloadPolicyUrl = (id) => window.open(PrivacyPolicyService.getDownloadPolicyUrl(id));
    vm.removePolicy = removePolicy;
    vm.isPolicyUploaded = isPolicyUploaded;

    // Initialize
    activate();

    /**
     * Initialize the controller
     */
    function activate() {
      PrivacyPolicyService.getDownloadDefaultPolicyUrlAsync().then(url => vm.defaultPolicyUrl = url);
      loadUploadedPolicies();
    }

    /**
     * Load uploaded policies from the server
     */
    function loadUploadedPolicies() {
      vm.isLoading = true;
      PrivacyPolicyService.getUploadedPolicies()
        .then(function (policies) {
          vm.uploadedPolicies = policies || {};
          vm.isLoading = false;
        })
        .catch(function (error) {
          vm.isLoading = false;
        });
    }

    /**
     * Handle file selection for upload
     */
    function onFileSelected(languageId, $event) {
      var files = $event.target.files;
      if (files && files.length > 0) {
        var file = files[0];

        // Validate file type
        if (file.type !== 'application/pdf') {
          $event.target.value = '';
          return;
        }

        // Store the selected file
        vm.selectedFiles[languageId] = file;
      }
    }

    /**
     * Upload a privacy policy for a language
     */
    function uploadPolicy(languageId) {
      if (!vm.selectedFiles[languageId]) {
        return;
      }

      var file = vm.selectedFiles[languageId];
      vm.isLoading = true;

      PrivacyPolicyService.uploadPolicy(file, languageId)
        .then(function (result) {
          vm.uploadedPolicies[languageId] = result;
          vm.selectedFiles[languageId] = null;
          // Reset file input
          var fileInput = document.querySelector('input[data-language="' + languageId + '"]');
          if (fileInput) {
            fileInput.value = '';
          }
          vm.isLoading = false;
        })
        .catch(function (error) {
          vm.isLoading = false;
        });
    }

    /**
     * Remove a privacy policy
     */
    function removePolicy(languageId) {
      vm.isLoading = true;

      PrivacyPolicyService.removePolicy(languageId)
        .then(function () {
          delete vm.uploadedPolicies[languageId];
          vm.isLoading = false;
        })
        .catch(function (error) {
          vm.isLoading = false;
        });
    }

    /**
     * Check if a policy is uploaded for a language
     */
    function isPolicyUploaded(languageId) {
      return vm.uploadedPolicies && vm.uploadedPolicies[languageId];
    }

    // Clean up on destroy
    $scope.$on('$destroy', function () {
      vm.selectedFiles = null;
    });
  }
})();


